import Vue from 'vue'
import Router from 'vue-router'
import { isLogin } from '../utils/auth'
import app from '../main'
// import NProgress from 'nprogress'

import { auth } from './auth'
import { user } from './user'
import { zujuanRouter } from './zujuan'
import { help } from './help'
import { isType } from '../utils/is-type'
import { APPLICATION_ID, LOGIN_URL } from '../config'
import { Base64UrlEncode } from '../utils'

// 404
const Page404 = () => import('../views/404.vue')

Vue.use(Router)
// console.log(Router.prototype, 'Router')
const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_ROUTER_URL,
  scrollBehavior (to, from, savedPosition) {
    let position = { x: 0, y: 0 }
    let matched = to.matched
    if (matched.some(item => item.meta.scrollToTop === false)) {
      delete position.x
      delete position.y
    }
    if (to.hash) {
      position.selector = to.hash
    } else if (savedPosition) {
      position = savedPosition
    }
    return position
  },
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  routes: [
    {
      path: '/',
      name: 'Index',
      alias: '/index',
      component: () => import('../views/index.vue')
    },
    ...zujuanRouter,
    {
      path: '/vip',
      name: 'VIP',
      component: () => import('../views/vip.vue'),
      meta: { title: '会员中心' }
    },
    {
      path: '/vip/pay',
      name: 'VIPPay',
      component: () => import('../views/vip-pay.vue'),
      meta: {
        title: '订单确认',
        prevRouter: {
          name: 'VIP',
          title: '会员中心'
        }
      }
    },
    // {
    //   path: '/vip-protocol',
    //   name: 'VIPProtocol',
    //   component: () => import('../views/vip-protocol.vue'),
    //   meta: { title: '会员开通协议' }
    // },
    ...auth, // 登录相关
    ...user, // 用户中心
    ...help, // 帮助中心
    {
      path: '*',
      name: '404',
      component: Page404
    }
  ]
})

router.beforeEach(function (to, from, next) {
  if (app && app.$Progress) {
    app.$Progress.start()
  }
  /**
   * 登录验证
   */
  let loginRoute = {}
  // 已登录用户中心帐号
  if (isLogin()) {
    next()
  } else {
    if (to.meta.auth === true) {
      let url = window.location.href
      window.location.href = LOGIN_URL + '?from=' + Base64UrlEncode(url) + '&id=' + APPLICATION_ID
      // loginRoute = { name: 'Login' }
      // loginRoute.query = { from: to.fullPath }
      // next(loginRoute)
    } else {
      next()
    }
  }
})

// router原型注册方法
Router.prototype.open = (route) => {
  return window.open(isType(route, 'string') && /^https?:\/\//.test(route) ? route : router.resolve(route).href, '_blank')
}

/**
 * @desc async 异步打开新窗口
 * @params hookFn {func} 钩子函数，函数接收route作为参数，用于异步回调执行时要打开的新路由
 * @return newWindowInstance
 */
Router.prototype.openAsync = (hookFn) => {
  let newWin = window.open('', '_blank')
  newWin.document.body.innerHTML = '努力加载中，请稍侯...'
  hookFn((route) => {
    newWin.location.href = router.resolve(route).href
  }, (msg) => {
    newWin.document.body.innerHTML = msg
  })
  return newWin
}

router.afterEach(function (to) {
  if (app && app.$Progress) {
    app.$Progress.finish()
  }
  // NProgress.done()
  // 统计代码
  /* global _hmt */
  _hmt.push(['_trackPageview', to.fullPath])
})

export default router
